import React from 'react';
import baseLoadable from '@loadable/component';

/**
 * Loadable options - the loadable-components options Perseus supports
 */
interface LoadableOptions {
    ssr?: boolean;
    fallback?: JSX.Element;
}

type LazyImportFn<T> = () => Promise<React.ComponentType<T> | { default: React.ComponentType<T> }>;

/**
 * loadable wrapper function over the loadable-components library with the supported options
 * Returns loadable-components HOC
 *
 * @param lazyImportFn component lazy import function.
 * @param loadableOptions loadable-components function options supported by perseus.
 */
const loadableComponent = <T>(
    lazyImportFn: LazyImportFn<T>,
    { ssr = true, fallback }: LoadableOptions = { ssr: true }
) => baseLoadable(lazyImportFn, { ssr, fallback });

export default loadableComponent;
